// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.2.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.2.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --space-025: calc(var(--space-1)*0.25);
  --space-05: calc(var(--space-1)*0.5);
  --space-1: 4px;
  --space-2: calc(var(--space-1)*2);
  --space-3: calc(var(--space-1)*3);
  --space-4: calc(var(--space-1)*4);
  --space-5: calc(var(--space-1)*5);
  --space-6: calc(var(--space-1)*6);
  --space-8: calc(var(--space-1)*8);
  --space-10: calc(var(--space-1)*10);
  --space-12: calc(var(--space-1)*12);
  --space-16: calc(var(--space-1)*16);
  --space-20: calc(var(--space-1)*20);
  --space-24: calc(var(--space-1)*24);
}

/*
 * Repeat the selector to trump the specificity
 * of other single class selectors.
 */

.d-stack-h.d-stack-h,
.d-stack-v.d-stack-v {
  display: flex;
  gap: var(--space, 0);
}

.d-stack-h {
  align-items: center;
  flex-direction: row;
}

.d-stack-h > * {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

.d-stack-v {
  flex-direction: column;
}

.d-stack-v > * {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
  }

/*
 * This inline container centers its children on
 * the line box and allows them to overflow it.
 */

.d-inline-stack {
  align-items: center;
  display: inline-flex;
  gap: var(--space, var(--space-05)); /* Different default than the other stacks! */
  height: 1lh;
  vertical-align: bottom;

  /* 0.25 em is roughly the width of a space. */
}

.d-inline-stack:not(:first-child) {
    margin-inline-start: 0.25em;
  }

.d-inline-stack:not(:last-child) {
    margin-inline-end: 0.25em;
  }

.space-0_25 {
  --space: var(--space-025);
}

.space-0_5 {
  --space: var(--space-05);
}

.space-1 {
  --space: var(--space-1);
}

.space-2 {
  --space: var(--space-2);
}

.space-3 {
  --space: var(--space-3);
}

.space-4 {
  --space: var(--space-4);
}

.space-5 {
  --space: var(--space-5);
}

.space-6 {
  --space: var(--space-6);
}

.space-8 {
  --space: var(--space-8);
}

.space-10 {
  --space: var(--space-10);
}

.space-12 {
  --space: var(--space-12);
}

.space-16 {
  --space: var(--space-16);
}

.space-20 {
  --space: var(--space-20);
}

.space-24 {
  --space: var(--space-24);
}
`, "",{"version":3,"sources":["webpack://./packages/ui/src/stack/stack-variables.css","webpack://./packages/ui/src/stack/stack.css"],"names":[],"mappings":"AAAA;EACE,sCAAwC;EACxC,oCAAsC;EACtC,cAAc;EACd,iCAAmC;EACnC,iCAAmC;EACnC,iCAAmC;EACnC,iCAAmC;EACnC,iCAAmC;EACnC,iCAAmC;EACnC,mCAAqC;EACrC,mCAAqC;EACrC,mCAAqC;EACrC,mCAAqC;EACrC,mCAAqC;AACvC;;ACbA;;;EAGE;;AACF;;EAEE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AAMrB;;AAJE;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;AAGF;EACE,sBAAsB;AAMxB;;AAJE;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;;AAGF;;;EAGE;;AACF;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC,EAAE,6CAA6C;EACjF,WAAW;EACX,sBAAsB;;EAEtB,6CAA6C;AAQ/C;;AAPE;IACE,2BAA2B;EAC7B;;AAEA;IACE,yBAAyB;EAC3B;;AAGF;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[":root {\n  --space-025: calc(0.25 * var(--space-1));\n  --space-05: calc(0.5 * var(--space-1));\n  --space-1: 4px;\n  --space-2: calc(2 * var(--space-1));\n  --space-3: calc(3 * var(--space-1));\n  --space-4: calc(4 * var(--space-1));\n  --space-5: calc(5 * var(--space-1));\n  --space-6: calc(6 * var(--space-1));\n  --space-8: calc(8 * var(--space-1));\n  --space-10: calc(10 * var(--space-1));\n  --space-12: calc(12 * var(--space-1));\n  --space-16: calc(16 * var(--space-1));\n  --space-20: calc(20 * var(--space-1));\n  --space-24: calc(24 * var(--space-1));\n}\n","@import './stack-variables.css';\n\n/*\n * Repeat the selector to trump the specificity\n * of other single class selectors.\n */\n.d-stack-h.d-stack-h,\n.d-stack-v.d-stack-v {\n  display: flex;\n  gap: var(--space, 0);\n}\n\n.d-stack-h {\n  align-items: center;\n  flex-direction: row;\n\n  & > * {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n}\n\n.d-stack-v {\n  flex-direction: column;\n\n  & > * {\n    margin-bottom: 0 !important;\n    margin-top: 0 !important;\n  }\n}\n\n/*\n * This inline container centers its children on\n * the line box and allows them to overflow it.\n */\n.d-inline-stack {\n  align-items: center;\n  display: inline-flex;\n  gap: var(--space, var(--space-05)); /* Different default than the other stacks! */\n  height: 1lh;\n  vertical-align: bottom;\n\n  /* 0.25 em is roughly the width of a space. */\n  &:not(:first-child) {\n    margin-inline-start: 0.25em;\n  }\n\n  &:not(:last-child) {\n    margin-inline-end: 0.25em;\n  }\n}\n\n.space-0_25 {\n  --space: var(--space-025);\n}\n\n.space-0_5 {\n  --space: var(--space-05);\n}\n\n.space-1 {\n  --space: var(--space-1);\n}\n\n.space-2 {\n  --space: var(--space-2);\n}\n\n.space-3 {\n  --space: var(--space-3);\n}\n\n.space-4 {\n  --space: var(--space-4);\n}\n\n.space-5 {\n  --space: var(--space-5);\n}\n\n.space-6 {\n  --space: var(--space-6);\n}\n\n.space-8 {\n  --space: var(--space-8);\n}\n\n.space-10 {\n  --space: var(--space-10);\n}\n\n.space-12 {\n  --space: var(--space-12);\n}\n\n.space-16 {\n  --space: var(--space-16);\n}\n\n.space-20 {\n  --space: var(--space-20);\n}\n\n.space-24 {\n  --space: var(--space-24);\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
